import { render } from "./top-right-bottom-left.md?vue&type=template&id=697aa934"
const script = {}
script.render = render

export default script